import React, {
    useContext,
    useEffect,
    useState,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import ZurichWhite from "../../assets/logos/zurich_white.png";
import TerraWindWhite from "../../assets/logos/terrawind_white.png";
import RivadaviaLogo from "../../assets/logos/rivadavia_logo.svg";
import CotizarContext from "./CotizarContext";
import ClienteDirectoContext from "../ClienteDirectoContext";


function isValidBase64(str) {
    return /^[A-Za-z0-9+/=]+$/.test(str) && str.length % 4 === 0;
}

const companiesDict = {
    "Sancor": {
        id: 1,
        logo: "https://i.imgur.com/F55GPdm.png", //TODO: use right link
        products: [{label: "AUTOMOTOR", value: "vehiculo"}, {
            label: "MICROSEGUROS",
            value: "microseguros"
        }, {label: "HOGAR", value: "hogar"}],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '2', CBU: '4'},
        idsTarjeta: [
            {value: '1', label: 'Cabal'},
            {value: '5', label: 'Visa'},
            {value: '7', label: 'Favacard'},
            {value: '9', label: 'American Express'},
            {value: '12', label: 'Naranja'},
            {value: '16', label: 'Diners Club'},
            {value: '18', label: 'Naranja Visa'},
            {value: '20', label: 'Cordobesa Mastercard'},
            {value: '23', label: 'TDF - Tierra del Fuego'},
            {value: '45', label: 'Mastercard Nueva'},
            {value: '57', label: 'ELEBAR'},
            {value: '70', label: 'Cencosud Mastercard'},
        ],
        equipoGncId: '1'
    },
    "RUS": {
        id: 2,
        logo: "https://i.imgur.com/WUaf6QD.png", //TODO: use right link
        products: [{label: "AUTOMOTOR", value: "vehiculo"}],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '2', CBU: '4'},
        idsTarjeta: [
            {value: '1', label: 'Visa'},
            {value: '3', label: 'Mastercard'},
            {value: '6', label: 'Naranja'},
            {value: '7', label: 'Cabal'},
            {value: '11', label: 'American Express'},
            {value: '14', label: 'Kadicard'},
            {value: '16', label: 'Nativa MasterCard'},
            {value: '18', label: 'CMR Falabella'},
            {value: '19', label: 'Tarjeta Plata'},
            {value: '22', label: 'Favacard'},
        ],
        equipoGncId: '1'
    },
    "Zurich": {
        id: 3,
        logo: ZurichWhite,
        products: [{label: "AUTOMOTOR", value: "vehiculo"}],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '4', CBU: '7'},
        idsTarjeta: [
            {value: '30654364229-2', label: 'Cabal'},
            {value: '30684195707-2', label: 'Nevada'},
            {value: '30598910045-2', label: 'Visa'},
            {value: '30574816870-2', label: 'Amex'},
            {value: '30536209383-2', label: 'KADICARD Pesos'},
            {value: '30579836268-2', label: 'Diners'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
            {value: '30522211563-2', label: 'Argen/Master'},
            {value: '30681424721-2', label: 'MIRA Pesos'},
            {value: '30685376349-2', label: 'Naranja'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
        ],
        equipoGncId: '3'
    },
    "TerraWind": {
        id: 4,
        logo: TerraWindWhite,
        products: [{label: "ASISTENCIA AL VIAJERO", value: "asistencia_viajero", key: "asistenciaViajero"}],
        razonSocial: "Terrawind",



        descuento: "prima",
        codigoFormasDePago: {TC: '4', CBU: '7', EF: '5'},
        idsTarjeta: [
            {value: '30654364229-2', label: 'Cabal'},
            {value: '30684195707-2', label: 'Nevada'},
            {value: '30598910045-2', label: 'Visa'},
            {value: '30574816870-2', label: 'Amex'},
            {value: '30536209383-2', label: 'KADICARD Pesos'},
            {value: '30579836268-2', label: 'Diners'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
            {value: '30522211563-2', label: 'Argen/Master'},
            {value: '30681424721-2', label: 'MIRA Pesos'},
            {value: '30685376349-2', label: 'Naranja'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
        ],
        bienesAdicionales: [],
        emissionStatus: {Success: "approved", Pending: "pending", Cancel: "rejected"},
        opcionesRolesExtra: [
            {value: '2', label: 'Asegurado'},
            {value: '1', label: 'Tomador'},
            {value: '3', label: 'Acreedor'},
        ],
        rolPrincipal: {value: '2', label: 'Asegurado'}
    },
    "Rivadavia": {
        id: 7,
        logo: RivadaviaLogo,
        products: [
            {label: "AUTOMOTOR", value: "vehiculo", key: "automotor", hasDeclaracionJurada: true},
            {label: "MOTOVEHÍCULO", value: "motovehiculo", key: "motovehiculo", hasDeclaracionJurada: true}
        ],
        codigoFormasDePago: {TC: 'TARJETA_CREDITO', CBU: 'CBU', EF: 'PAGO_FACIL'},
        formasDePago: {
            automotor: ["TC", "CBU", "EF"],
            motovehiculo: ["TC", "CBU", "EF"],
        },
        idsTarjeta: [
            {value: 'ARGENCARD_MASTERCARD', label: 'Argencard/Mastercard'},
            {value: 'VISA', label: 'Visa'},
            {value: 'DINERS', label: 'Diners'},
            {value: 'CABAL', label: 'Cabal'},
            {value: 'CARTA_AUSTRAL', label: 'Carta Austral'},
            {value: 'FAVACARD', label: 'Favacard'},
            {value: 'AMERICAN_EXPRESS', label: 'American Express'},
            {value: 'AUTOMATICA', label: 'Automatica'},
            {value: 'NARANJA', label: 'Naranja'},
            {value: 'SUCREDITO', label: 'Sucredito'},
            {value: 'NATIVA', label: 'Nativa'},
            {value: 'COOPEPLUS', label: 'CoopePlus'},
            {value: 'DATA_2000', label: 'Data 2000'}
        ],
        equipoGncId: "13",
    },
}

const companiesIdDict = {
    1: "Sancor",
    2: "RUS",
    3: "Zurich",
    4: "Terrawind",
    7: "Rivadavia"
}

const coberturasAutomotorNames = {
    "names": {
        "RC": "Responsabilidad civil",
        "IT": "Incendio total",
        "IP": "Incendio parcial",
        "RHT": "Robo y/o hurto total",
        "RHP": "Robo y/o hurto parcial",
        "AT": "Accidente total",
        "APD": "Accidente parcial según deducible",
        "LTP": "Lock out o tumulto popular",
        "GTI": "Granizo / Terremoto / Indundación total y parcial",
        "RCR": "Rotura de cristales",
        "RCE": "Rotura de cerraduras",
        "RRH": "Reposición de ruedas en caso de robo o hurto",
        "DPR": "Daños parciales al amparo del Robo Total",
        "CPL": "Extensión de Cobertura a países limítrofes",
        "AV": "Asistencia al vehículo",
        "SCS": "CLEAS (Sistema Compensación de Siniestros)",
    },
}

const provinciasList = [
    {'value': 1, 'label': 'CIUDAD AUTONOMA DE BUENOS AIRES (CABA)'},
    {'value': 2, 'label': 'BUENOS AIRES'},
    {'value': 3, 'label': 'CATAMARCA'},
    {'value': 4, 'label': 'CORDOBA'},
    {'value': 5, 'label': 'CORRIENTES'},
    {'value': 6, 'label': 'ENTRE RIOS'},
    {'value': 7, 'label': 'JUJUY'},
    {'value': 8, 'label': 'MENDOZA'},
    {'value': 9, 'label': 'LA RIOJA'},
    {'value': 10, 'label': 'SALTA'},
    {'value': 11, 'label': 'SAN JUAN'},
    {'value': 12, 'label': 'SAN LUIS'},
    {'value': 13, 'label': 'SANTA FE'},
    {'value': 14, 'label': 'SANTIAGO DEL ESTERO'},
    {'value': 15, 'label': 'TUCUMAN'},
    {'value': 16, 'label': 'CHACO'},
    {'value': 17, 'label': 'CHUBUT'},
    {'value': 18, 'label': 'FORMOSA'},
    {'value': 19, 'label': 'MISIONES'},
    {'value': 20, 'label': 'NEUQUEN'},
    {'value': 21, 'label': 'LA PAMPA'},
    {'value': 22, 'label': 'RIO NEGRO'},
    {'value': 23, 'label': 'SANTA CRUZ'},
    {'value': 24, 'label': 'TIERRA DEL FUEGO'}
]

const coberturasMotovehiculoNames = {
    "names": {
        "RC": "Responsabilidad civil",
        "IT": "Incendio total",
        "IP": "Incendio parcial",
        "RHT": "Robo y/o hurto total",
        "RHP": "Robo y/o hurto parcial",
        "AT": "Accidente total",
        "GIT": "Granizo / Inundación / Terremoto",
        "DPC": "Daños por robo o intento de robo (Cerraduras)",
        "DT": "Cláusula destrucción total del 80%",
        "AV": "Asistencia al vehículo",
        "EC": "Extensión de Cobertura a países limítrofes"
    },
}

const GENERIC_OPTIONS_FORMAS_DE_PAGO = [
    {label: 'Tarjeta de crédito', value: 'TC'},
    {label: 'Débito por CBU', value: 'CBU'},
];

const COBERTURAS_ADICIONALES_ORDER = [48, 36, 37, 26];

const CotizarContextProvider = ({
                                           children,
                                       }) => {
        const cdContext = useContext(ClienteDirectoContext);
        const hasClienteDirecto = cdContext && cdContext.isCotizarReady !== undefined;

        // VEHICULO
        const [autosMarcas, setAutosMarcas] = useState(null)
        const [localidades, setLocalidades] = useState(null)
        // MOTO
        const [motosMarcas, setMotosMarcas] = useState(null)
        //HOGAR
        const [coberturasInfo, setCoberturasInfo] = useState(null);
        //PRODUCTOS
        const [coberturasProductsInfo, setCoberturasProductsInfo] = useState(null);

        const [isReady, setIsReady] = useState(false);

        useEffect(() => {
                if (hasClienteDirecto) return;

                let shouldUpdate = true;

                const init = async () => {
                    let coberturasInfoDict = {};

                    let urlRequestOne = process.env.REACT_APP_BACK_SERVER + '/cd/getDatosCotizar'
                    let urlRequestTwo = process.env.REACT_APP_QUOTATION_MICROSERVICE + '/getInformacionCoberturas'

                    const requestOne = axios.get(urlRequestOne);
                    const requestTwo = axios.get(urlRequestTwo);

                    axios.all([requestOne, requestTwo])
                        .then(axios.spread((responseOne, responseTwo) => {
                                if (shouldUpdate) {
                                    let options = responseOne['data']['localidades'].map(d => ({
                                        "value": `${d.CodPostal.toString()},${d.CodSancorLocalidad.toString()},${d.CodRUSLocalidad.toString()}`,
                                        "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
                                    }));
                                    setLocalidades(options)

                                    setCoberturasInfo(responseOne['data']['coberturas_hogar'])
                                    setAutosMarcas(responseOne['data']['marcas_auto'].map(d => ({
                                        "value": d,
                                        "label": d
                                    })))
                                    setMotosMarcas(responseOne['data']['marcas_moto'].map(d => ({
                                        "value": d,
                                        "label": d
                                    })))

                                    coberturasInfoDict["vehiculo"] = {
                                        ...responseTwo["data"]["coberturas_auto"],
                                        ...coberturasAutomotorNames
                                    }
                                    coberturasInfoDict["motovehiculo"] = {
                                        ...responseTwo["data"]["coberturas_motovehiculo"],
                                        ...coberturasMotovehiculoNames
                                    }

                                    setCoberturasProductsInfo(coberturasInfoDict)

                                    setIsReady(true);
                                }
                            }
                        ))
                }
                init();
                return () => {
                    shouldUpdate = false;
                };
            }, [hasClienteDirecto]
        )

        const resolvedContext = useMemo(
            () =>
                hasClienteDirecto
                    ? {
                        genericOptionsFormasDePago: cdContext.genericOptionsFormasDePago,
                        autosMarcas: cdContext.autosMarcas,
                        motosMarcas: cdContext.motosMarcas,
                        localidades: cdContext.localidades,
                        coberturasInfo: cdContext.coberturasInfo,
                        coberturasAdicionalesOrder: cdContext.coberturasAdicionalesOrder,
                        companiesDict,
                        companiesIdDict,
                        provinciasList,
                        coberturasProductsInfo: cdContext.coberturasProductsInfo,
                        isReady: cdContext.isCotizarReady,
                    }
                    : {
                        genericOptionsFormasDePago: GENERIC_OPTIONS_FORMAS_DE_PAGO,
                        autosMarcas,
                        motosMarcas,
                        localidades,
                        coberturasInfo,
                        coberturasAdicionalesOrder: COBERTURAS_ADICIONALES_ORDER,
                        companiesDict,
                        companiesIdDict,
                        provinciasList,
                        coberturasProductsInfo,
                        isReady,
                    },
            [
                hasClienteDirecto,
                cdContext?.genericOptionsFormasDePago,
                cdContext?.autosMarcas,
                cdContext?.motosMarcas,
                cdContext?.localidades,
                cdContext?.coberturasInfo,
                cdContext?.coberturasAdicionalesOrder,
                cdContext?.coberturasProductsInfo,
                cdContext?.isCotizarReady,
                autosMarcas,
                motosMarcas,
                localidades,
                coberturasInfo,
                coberturasProductsInfo,
                isReady,
            ]
        );

        return (
            <CotizarContext.Provider value={resolvedContext}>
                {children}
            </CotizarContext.Provider>
        );
    }
;

CotizarContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CotizarContextProvider;